import { connect } from 'react-redux';
import { get } from 'lodash';

import { getSelectedMapLayer, isMultiLayerZoneGenerationEnabled } from 'manual/selectors';
import { isResourceTypeLoaded } from 'loading/selectors';

import { requestManualGeneratedZones } from 'manual/requesters';

import ZoneGenerationReview from 'manual/ZoneGenerationReview';
import { formatZoneRowsForReview } from 'manual/zoneTableUtil';

import { resourceType } from '../constants/loading';

export default connect(
  state => {
    const isMultiLayerEnabled = isMultiLayerZoneGenerationEnabled(state);
    const mapLayer = getSelectedMapLayer(state);
    const zones = get(mapLayer, 'zones');
    const zoneRows = zones ? formatZoneRowsForReview(zones, isMultiLayerEnabled) : [];

    return {
      areMapLayersLoaded: isResourceTypeLoaded({
        state,
        type: resourceType.MAP_ZONES
      }),
      zoneRows
    };
  },
  dispatch => ({
    fetchMapZones: (numZones) => {
      dispatch(requestManualGeneratedZones(numZones));
    }
  })
)(ZoneGenerationReview);
